<template>
    <!-- The outer wrapper and the Bootstrap alert classes are both load-bearing:
         callers put their own class on this component (so it lands on the outer
         div) and then style the inner element as a descendant — see
         MultiRecipeProductionView's `.production-draft-notice :deep(.alert)`,
         TemperatureView and CheckScheduler. Collapsing this to a single root, or
         dropping the alert classes, silently breaks those views. The rules below
         out-specify Bootstrap's own look without removing those hooks. -->
    <div class="text-center w-100">
        <div :class="['alert', alertClass, 'forkto-notice']" :data-tone="tone" role="status">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "AppNotice",
    props: {
        primary: {
            type: Boolean,
            default: false
        },
        secondary: {
            type: Boolean,
            default: false
        },
        success: {
            type: Boolean,
            default: false
        },
        danger: {
            type: Boolean,
            default: false
        },
        warning: {
            type: Boolean,
            default: false
        },
        info: {
            type: Boolean,
            default: false
        },
        light: {
            type: Boolean,
            default: false
        },
        dark: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        alertType() {
            if (this.primary) return "primary";
            if (this.secondary) return "secondary";
            if (this.success) return "success";
            if (this.danger) return "danger";
            if (this.warning) return "warning";
            if (this.info) return "info";
            if (this.light) return "light";
            if (this.dark) return "dark";
            return "primary"; // Default type if none provided
        },
        alertClass() {
            return `alert-${this.alertType}`;
        },

        /**
         * Bootstrap's `.alert-primary` default painted every empty state a
         * saturated blue, which read as a message the user had to act on. The
         * neutral tones now render quietly; only the genuinely semantic ones
         * (success / danger / warning) keep colour.
         */
        tone() {
            if (this.success) return "success";
            if (this.danger) return "danger";
            if (this.warning) return "warning";
            return "neutral";
        }
    }
};
</script>

<style scoped>
.forkto-notice.alert {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    width: 100%;
    padding: 2rem 1.25rem;
    color: var(--forkto-ink-3);
    font-size: 0.875rem;
    text-align: center;
    background: var(--forkto-surface);
    border: 1px solid var(--forkto-line);
    border-radius: var(--forkto-radius-surface);
}

.forkto-notice.alert[data-tone="success"] {
    color: var(--forkto-ink-2);
    background: var(--forkto-pass-soft);
    border-color: var(--forkto-pass-line);
}

.forkto-notice.alert[data-tone="warning"] {
    color: var(--forkto-ink-2);
    background: var(--forkto-warn-soft);
    border-color: var(--forkto-warn-line);
}

.forkto-notice.alert[data-tone="danger"] {
    color: var(--forkto-ink-2);
    background: var(--forkto-fail-soft);
    border-color: var(--forkto-fail-line);
}
</style>
